/*
  JDM Year / Make / Model finder for the Featured Products section.
  Products have no fitment data, so year ranges and models are read from product titles.
  Make comes from the title (Lexus, Acura...) or falls back to the vendor's family.
*/
(function () {
  // [make, family vendor, title words that name the make, models as [label, pattern]]
  const MAKES = [
    ['Honda', 'HONDA', /\bHONDA\b/i, [
      ['Accord', /\bACCORD\b/i], ['Civic', /\bCIVIC\b/i], ['CR-V', /\bCR-?V\b/i], ['Crosstour', /\bCROSSTOUR\b/i],
      ['Element', /\bELEMENT\b/i], ['Fit', /\bFIT\b|\bJAZZ\b/i], ['HR-V', /\bHR-?V\b/i], ['Insight', /\bINSIGHT\b/i],
      ['Odyssey', /\bOD[YE]SS?E?Y\b/i], ['Pilot', /\bPILOT\b/i], ['Prelude', /\bPRELUDE\b/i], ['Ridgeline', /\bRIDGELINE\b/i],
      ['S2000', /\bS2000\b/i],
    ]],
    ['Acura', 'HONDA', /\bACURA\b/i, [
      ['Integra', /\bINTEGRA\b/i], ['RL', /\bRL\b/i], ['RSX', /\bRSX\b/i], ['TL', /\bTL\b/i], ['TSX', /\bTSX\b/i],
      ['MDX', /\bMDX\b/i], ['RDX', /\bRDX\b/i], ['ILX', /\bILX\b/i],
    ]],
    ['Toyota', 'TOYOTA', /\bTOYOTA\b/i, [
      ['4Runner', /\b4\s?-?RUNNER\b/i], ['Altezza', /\bALTEZZA\b/i], ['Avalon', /\bAVALON\b/i], ['C-HR', /\bC-?HR\b|\bCH-R\b/i],
      ['Camry', /\bCAMRY\b/i], ['Celica', /\bCELICA\b/i], ['Century', /\bCENTURY\b/i], ['Chaser', /\bCHASER\b/i],
      ['Corolla', /\bCOROLLA\b/i], ['Echo', /\bECHO\b/i], ['GT86', /\bGT\s?86\b/i], ['Highlander', /\bHIG?H?LANDER\b/i],
      ['Matrix', /\bMATRIX\b/i], ['Pickup', /\bPICK\s?-?UP\b/i], ['Prius', /\bPRIUS\b/i], ['RAV4', /\bRAV\s?-?4\b/i],
      ['Sequoia', /\bSEQUOIA\b/i], ['Sienna', /\bSIENNA\b/i], ['Solara', /\bSOLARA\b/i], ['Starlet', /\bSTARLET\b/i],
      ['Supra', /\bSUPRA\b/i], ['T100', /\bT100\b/i], ['Tacoma', /\bTACOMA\b/i], ['Tundra', /\bTUNDRA\b/i],
      ['Venza', /\bVENZA\b/i], ['Yaris', /\bYARIS\b/i],
    ]],
    ['Lexus', 'TOYOTA', /\bLEXUS\b/i, [
      ['CT200h', /\bCT\s?200H?\b/i], ['ES300', /\bES\s?300\b/i], ['ES330', /\bES\s?330\b/i], ['ES350', /\bES\s?350\b/i],
      ['GS300', /\bGS\s?300\b/i], ['GS350', /\bGS\s?350\b/i], ['GS430', /\bGS\s?430\b/i], ['GX470', /\bGX\s?470\b/i],
      ['IS250', /\bIS\s?250\b/i], ['IS300', /\bIS\s?300\b/i], ['IS350', /\bIS\s?350\b/i], ['LS400', /\bLS\s?400\b/i],
      ['LS430', /\bLS\s?430\b/i], ['LS460', /\bLS\s?460\b/i], ['RX300', /\bRX\s?300\b/i], ['RX330', /\bRX\s?330\b/i],
      ['RX350', /\bRX\s?350\b/i], ['SC300', /\bSC\s?300\b/i], ['SC400', /\bSC\s?400\b/i], ['SC430', /\bSC\s?430\b/i],
    ]],
    ['Scion', 'TOYOTA', /\bSCION\b/i, [
      ['FR-S', /\bFR-?S\b/i], ['tC', /\bSCION\s?TC\b/i], ['xB', /\bXB\b/i], ['xD', /\bXD\b/i],
    ]],
    ['Nissan', 'NISSAN', /\bNISSAN\b/i, [
      ['240SX', /\b240\s?SX\b/i], ['300ZX', /\b300\s?ZX\b/i], ['350Z', /\b350\s?Z\b/i], ['370Z', /\b370\s?Z\b/i],
      ['Altima', /\bALTIMA\b/i], ['Frontier', /\bFRONTIER\b/i], ['Maxima', /\bMAXIMA\b/i], ['Murano', /\bMURANO\b/i],
      ['NV200', /\bNV\s?200\b/i], ['Pathfinder', /\bPATHFINDER\b/i], ['Quest', /\bQUEST\b/i], ['Rogue', /\bROGUE\b/i],
      ['Sentra', /\bSENTRA\b/i], ['Silvia', /\bSILVIA\b|\bS1[345]\b/i], ['Skyline', /\bSKYLINE\b/i], ['Titan', /\bTITAN\b/i],
      ['Versa', /\bVERSA\b/i], ['Xterra', /\bXTERRA\b/i],
    ]],
    ['Infiniti', 'NISSAN', /\bINFINITI\b/i, [
      ['EX35', /\bEX\s?35\b/i], ['FX35', /\bFX\s?35\b/i], ['FX37', /\bFX\s?37\b/i], ['G35', /\bG\s?35\b/i],
      ['G37', /\bG\s?37\b/i], ['M35', /\bM\s?35\b/i], ['M37', /\bM\s?37\b/i], ['Q50', /\bQ\s?50\b/i],
      ['Q60', /\bQ\s?60\b/i], ['QX70', /\bQX\s?70\b/i],
    ]],
    ['Subaru', 'SUBARU', /\bSUBARU\b/i, [
      ['Baja', /\bBAJA\b/i], ['BRZ', /\bBRZ\b/i], ['Crosstrek', /\bCROSSTREK\b|\bXV\b/i], ['Forester', /\bFORESTER\b/i],
      ['Impreza', /\bIMPREZA\b/i], ['Legacy', /\bLEGACY\b/i], ['Outback', /\bOUTBACK\b/i], ['Tribeca', /\bTRIBECA\b/i],
      ['WRX / STI', /\bWRX\b|\bSTI\b/i],
    ]],
    ['Mazda', 'MAZDA', /\bMAZDA\b/i, [
      ['CX-7', /\bCX-?7\b/i], ['CX-9', /\bCX-?9\b/i], ['Mazda3', /\bMAZDA\s?3\b/i], ['Mazda6', /\bMAZDA\s?6\b/i],
      ['Mazdaspeed3', /\bMAZDA\s?SPEED\s?3\b|\bSPEED\s?3\b/i], ['Miata', /\bMIATA\b|\bMX-?5\b/i],
      ['RX-7', /\bRX-?7\b/i], ['RX-8', /\bRX-?8\b/i], ['Tribute', /\bTRIBUTE\b/i],
    ]],
    ['Mitsubishi', 'MITSUBISHI', /\bMITSUBISHI\b/i, [
      ['Eclipse', /\bECLIPSE\b/i], ['Galant', /\bGALANT\b/i], ['Lancer', /\bLANCER\b/i], ['Lancer Evolution', /\bEVO(LUTION)?\b/i],
      ['Outlander', /\bOUTLANDER\b/i],
    ]],
    ['Hyundai', 'HYUNDAI', /\bH[YU]{1,2}N?D?AI\b/i, [
      ['Accent', /\bACCENT\b/i], ['Azera', /\bAZERA\b/i], ['Elantra', /\bELANTRA\b/i], ['Genesis', /\bGENESIS\b/i],
      ['Ioniq', /\bIONIQ\b/i], ['Kona', /\bKONA\b/i], ['Santa Fe', /\bSANTA\s?FE\b/i], ['Sonata', /\bSONATA\b/i],
      ['Tucson', /\bTUCSON\b/i], ['Veloster', /\bVELOSTER\b/i],
    ]],
    ['Kia', 'KIA', /\bKIA\b/i, [
      ['Cadenza', /\bCADENZA\b/i], ['Forte', /\bFORTE\b/i], ['K5', /\bK5\b/i], ['Kona', /\bKONA\b/i], ['Niro', /\bNIRO\b/i],
      ['Optima', /\bOPTIMA\b/i], ['Rio', /\bRIO\b/i], ['Sedona', /\bSEDONA\b/i], ['Seltos', /\bSELTOS\b/i],
      ['Sorento', /\bSORENTO\b/i], ['Soul', /\bSOUL\b/i], ['Sportage', /\bSPORTAGE\b/i],
    ]],
  ];
  const MIN_YEAR = 1980;
  const MAX_YEAR = new Date().getFullYear() + 1;

  const fullYear = (y, ref) => {
    if (y.length >= 4) return Number(y.slice(0, 4));
    const n = Number(y);
    if (ref) return Number(String(ref).slice(0, 2) + y.padStart(2, '0'));
    return n < 40 ? 2000 + n : 1900 + n;
  };

  // "2001-2005", "2001 - 2005", "02-05", "2001-20017" (typo), "06 07 2008 2009", "2013 2014 2015"
  function parseYears(title) {
    const t = title.replace(/[–—]/g, '-');
    const years = new Set();
    const addRange = (a, b) => {
      if (a > b) [a, b] = [b, a];
      if (a < MIN_YEAR || b > MAX_YEAR || b - a > 40) return;
      for (let y = a; y <= b; y++) years.add(y);
    };
    let m;
    const range4 = /\b((?:19|20)\d{2})\s*-\s*((?:19|20)\d{2,3}|\d{2})\b/g;
    while ((m = range4.exec(t))) addRange(Number(m[1]), fullYear(m[2], m[1]));
    const range2 = /(?:^|[^\d.])(\d{2})\s*-\s*(\d{2})(?![\d.])/g;
    while ((m = range2.exec(t))) {
      const a = fullYear(m[1]);
      const b = fullYear(m[2]);
      if (b >= a) addRange(a, b);
    }
    const single = /\b((?:19|20)\d{2})\b/g;
    while ((m = single.exec(t))) {
      const y = Number(m[1]);
      if (y >= MIN_YEAR && y <= MAX_YEAR) years.add(y);
    }
    // "2006 2012 LEXUS IS250" means 2006 through 2012
    const spaced = /\b((?:19|20)\d{2})\s+(?=((?:19|20)\d{2})\b)/g;
    while ((m = spaced.exec(t))) addRange(Number(m[1]), Number(m[2]));
    // "06 07 2008 2009": two-digit years leading into a run of four-digit years
    const shortLead = /\b(\d{2})\s+(?=(?:\d{2}\s+)*(?:19|20)\d{2}\b)/g;
    while ((m = shortLead.exec(t))) years.add(fullYear(m[1]));
    return [...years].sort((a, b) => a - b);
  }

  // Returns [[make, model], ...] for every vehicle named in the title
  function parseFitments(title, vendor) {
    const v = String(vendor || '').toUpperCase();
    const out = [];
    for (const [make, family, makeWord, models] of MAKES) {
      const named = makeWord.test(title);
      if (!named && family !== v) continue;
      for (const [label, re] of models) {
        if (re.test(title)) out.push([make, label]);
      }
    }
    return out;
  }

  function buildIndex(products) {
    return products
      .map((p) => ({
        h: p.handle,
        a: p.variants.some((variant) => variant.available) ? 1 : 0,
        y: parseYears(p.title),
        f: parseFitments(p.title, p.vendor),
      }))
      .filter((p) => p.y.length && p.f.length);
  }

  const api = { parseYears, parseFitments, buildIndex };
  if (typeof module !== 'undefined') module.exports = api;
  if (typeof window === 'undefined') return;
  window.JdmYmm = api;

  const CACHE_KEY = 'jdm-ymm-index-v1';
  const BATCH = 12;
  let indexPromise = null;

  function loadIndex() {
    if (indexPromise) return indexPromise;
    indexPromise = (async () => {
      try {
        const cached = sessionStorage.getItem(CACHE_KEY);
        if (cached) return JSON.parse(cached);
      } catch (e) {}
      const products = [];
      for (let page = 1; page <= 10; page++) {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}products.json?limit=250&page=${page}`);
        if (!res.ok) throw new Error(`products.json ${res.status}`);
        const batch = (await res.json()).products;
        products.push(...batch);
        if (batch.length < 250) break;
      }
      const index = buildIndex(products);
      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(index));
      } catch (e) {}
      return index;
    })();
    indexPromise.catch(() => (indexPromise = null));
    return indexPromise;
  }

  function fillSelect(select, placeholder, values) {
    select.innerHTML = '';
    select.append(new Option(placeholder, ''));
    values.forEach((v) => select.append(new Option(String(v).toUpperCase(), v)));
    select.disabled = values.length === 0;
  }

  function initFinder(root) {
    const grid = document.getElementById(root.dataset.gridId);
    const status = document.getElementById(root.dataset.statusId);
    const yearSel = root.querySelector('[data-ymm="year"]');
    const makeSel = root.querySelector('[data-ymm="make"]');
    const modelSel = root.querySelector('[data-ymm="model"]');
    const findBtn = root.querySelector('[data-ymm="find"]');
    const resetBtn = root.querySelector('[data-ymm="reset"]');
    const moreBtn = document.getElementById(root.dataset.moreId);
    if (!grid || !yearSel || !makeSel || !modelSel || !findBtn) return;

    const originalGrid = grid.innerHTML;
    let index = [];
    let queue = [];
    let renderToken = 0;

    const matches = (p, year, make, model) =>
      (!year || p.y.includes(year)) && p.f.some(([mk, md]) => (!make || mk === make) && (!model || md === model));
    const sorted = (values) => [...new Set(values)].sort((a, b) => String(a).localeCompare(String(b)));

    function refreshYears() {
      const years = [...new Set(index.flatMap((p) => p.y))].sort((a, b) => b - a);
      fillSelect(yearSel, 'YEAR', years);
    }
    function refreshMakes() {
      const year = Number(yearSel.value) || 0;
      const makes = year ? sorted(index.filter((p) => p.y.includes(year)).flatMap((p) => p.f.map(([mk]) => mk))) : [];
      fillSelect(makeSel, 'MAKE', makes);
      refreshModels();
    }
    function refreshModels() {
      const year = Number(yearSel.value) || 0;
      const make = makeSel.value;
      const models = year && make
        ? sorted(index.filter((p) => p.y.includes(year)).flatMap((p) => p.f.filter(([mk]) => mk === make).map(([, md]) => md)))
        : [];
      fillSelect(modelSel, 'ALL MODELS', models);
      findBtn.disabled = !(year && make);
    }

    async function ensureIndex() {
      if (index.length) return;
      yearSel.disabled = true;
      yearSel.options[0].textContent = 'LOADING…';
      try {
        index = await loadIndex();
        refreshYears();
      } catch (e) {
        yearSel.options[0].textContent = 'YEAR';
        yearSel.disabled = false;
      }
    }

    async function renderCard(handle) {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}?section_id=jdm-ymm-card`);
      if (!res.ok) return '';
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const card = doc.querySelector('.jdm-ymm-card');
      return card ? `<div class="grid__item">${card.innerHTML}</div>` : '';
    }

    async function renderNext(token) {
      const batch = queue.splice(0, BATCH);
      if (moreBtn) moreBtn.hidden = true;
      const html = await Promise.all(batch.map(renderCard));
      if (token !== renderToken) return;
      grid.insertAdjacentHTML('beforeend', html.join(''));
      if (moreBtn) moreBtn.hidden = queue.length === 0;
    }

    async function find() {
      const year = Number(yearSel.value);
      const make = makeSel.value;
      const model = modelSel.value;
      if (!year || !make) return;
      // In-stock first, sold-out last, keeping store order within each group
      const found = index.filter((p) => matches(p, year, make, model));
      queue = [...found.filter((p) => p.a), ...found.filter((p) => !p.a)].map((p) => p.h);
      const token = ++renderToken;
      grid.innerHTML = '';
      const label = `${year} ${make}${model ? ' ' + model : ''}`;
      if (status) status.textContent = found.length
        ? `${found.length} ${found.length === 1 ? 'part fits' : 'parts fit'} your ${label}`
        : `No parts found for your ${label}. Call us and we will find one for you.`;
      if (resetBtn) resetBtn.hidden = false;
      if (queue.length) await renderNext(token);
    }

    function reset() {
      renderToken++;
      queue = [];
      grid.innerHTML = originalGrid;
      if (status) status.textContent = '';
      if (moreBtn) moreBtn.hidden = true;
      if (resetBtn) resetBtn.hidden = true;
      yearSel.value = '';
      refreshMakes();
    }

    yearSel.addEventListener('change', refreshMakes);
    makeSel.addEventListener('change', refreshModels);
    findBtn.addEventListener('click', find);
    if (resetBtn) resetBtn.addEventListener('click', reset);
    if (moreBtn) moreBtn.addEventListener('click', () => renderNext(renderToken));
    ['pointerdown', 'focusin'].forEach((type) => root.addEventListener(type, ensureIndex, { once: true }));
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          io.disconnect();
          ensureIndex();
        }
      }, { rootMargin: '300px' });
      io.observe(root);
    }
  }

  const start = () => document.querySelectorAll('[data-jdm-ymm]').forEach(initFinder);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
